module.exports = __webpack_public_path__ + "static/media/pers_schutz_false_active.0a44837a.jpg";